<template>
  <div class="modal fade create-new-user-modal" id="CreateOperationModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar Operação</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" v-on:submit="createOperationMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar uma operação</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="operation_name" class="form-label fw-medium"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="operation_name"
                      placeholder="Digite o nome da operação"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateOperation">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonCreateOperation" class="btn btn-success">Criar operação</button>
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';

export default {
  name: "CreateOperationModal",
  data () {
    return {}
  },
  methods: {
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    createOperationMethod(){
      event.preventDefault();

      const operation_name = document.getElementById("operation_name").value;
      
      let error = false;

      if(operation_name == ""){
        this.alertResponse("Por favor preencha o campo nome", true);
        return;
      }

      if(error){
        return;
      }

      const objOperationCreate= {
        "name": operation_name
      }

      const buttonCreateOperation = this.$refs.buttonCreateOperation;
      buttonCreateOperation.disabled = true;
      buttonCreateOperation.innerHTML = "Criando operação...";
      const alertResponse = this.alertResponse;

      api.axios.post("/api/create/operation", objOperationCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonCreateOperation.innerHTML = "Criar operação";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonCreateOperation.innerHTML = "Operação criada com sucesso !";
          window.location.reload();
        } else {
          buttonCreateOperation.disabled = false;
          buttonCreateOperation.innerHTML = "Criar operação";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateOperation").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateOperation").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }
    },
  }
};
</script>